/* eslint-disable */
import Dashboard from './dashboard';
import qpEmployeeDashboard from 'sidemenu/menu-items(qp-employee)/dashboard';
// ==============================|| MENU ITEMS ||============================== //
const isQpEmployee = window.location.pathname.startsWith('/qp-employee');
let selectedMenu;
if (isQpEmployee) {
    selectedMenu = qpEmployeeDashboard;
} else {
    selectedMenu = Dashboard;
}
const superDistributorEmployeeMenuItems = {
    items: [selectedMenu]
};

export default superDistributorEmployeeMenuItems;
